module.exports = __webpack_public_path__ + "img/logo_aejsr.ce18f30b.png";